export const SMART_RATE_FAQ_SECTION_SCOPE = 'smart-rate-faq-section';

export const SMART_RATE_FAQ_IDS = Object.freeze({
  CLASSPASS_CREDITS: '1YGm53r4zGXFUd7nbSSAfV',
  CREDIT_LEVELS: '28VEWIUs1XvKkKtP9DHD0s',
  UNFILLED_SPOTS: 'GH9Bj7MCIBOcbGrlvFey4',
});
